import { render, staticRenderFns } from "./btnRedirect.vue?vue&type=template&id=7bd26603&scoped=true&"
import script from "./btnRedirect.vue?vue&type=script&lang=js&"
export * from "./btnRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd26603",
  null
  
)

export default component.exports